import { all, call, put, takeLatest } from 'redux-saga/effects';
import { EnvironmentApi } from 'vrlcm-gui-api';
import {
  InitializeStepPrecheck,
  initializeStepPrecheckFailed,
  initializeStepPrecheckSuccess
} from '../../../actions/workflows/steps/Precheck';
import * as Constants from '../../../constants/action-constants';

function* initializeStepPrecheck(action: InitializeStepPrecheck) {
  try {
    const environment = yield call(
      EnvironmentApi.getEnvironmentDataById,
      action.payload.environmentId
    );
    yield put(initializeStepPrecheckSuccess(environment));
  } catch (e) {
    if (e.response.status === 404) {
      yield put(initializeStepPrecheckSuccess());
    } else {
      yield put(initializeStepPrecheckFailed());
    }
  }
}

function* watchForInitializePrecheck() {
  yield takeLatest(Constants.INITIALIZE_STEP_PRECHECK, initializeStepPrecheck);
}

export default function* precheckSaga() {
  yield all([watchForInitializePrecheck()]);
}
